export default "__VITE_ASSET__D3e44YAt__"